import { Fragment } from "react";
import { useLanguageContext } from "../../context/LanguageContext";
import { useListContext } from "../../provider/ListProvider";
import { FormControl, FormLabel, Option, Select } from "@mui/joy";
import { useIsReadParam } from "../../utils/hooks/paramsHelpers";
import { useParamsContext } from "../../provider/ParamsProvider";

const { makeFilter, SearchFilter, useFilter } = require("../../components/MakeFilter");
const statusFilter = () => {
    const { t } = useLanguageContext();
    let [statusFilter, setStatusFilter] = useIsReadParam()
    let { setPage } = useListContext();
    let { flushParams } = useParamsContext();

    return (
        <Fragment>
            <FormControl size="sm">
                <FormLabel>{t('Is read')}</FormLabel>
                <Select
                    size="sm"
                    placeholder={t('Is read')}
                    slotProps={{
                        button: { sx: { whiteSpace: 'nowrap' } },
                        listbox: { placement: 'bottom-end' },
                    }}
                    onChange={(e, v) => {
                        setStatusFilter(v)
                        setPage(1)
                        flushParams();
                    }}
                    value={statusFilter}
                >
                    <Option value="">{t('Unread')}</Option>
                    <Option value="read">{t('Read')}</Option>
                    <Option value="all">{t('All')}</Option>
                </Select>
            </FormControl>
        </Fragment>
    )
};

const MessageFilter = makeFilter(SearchFilter, statusFilter, 'Search for User message')
export default MessageFilter